import _get from 'lodash/get'
import _set from 'lodash/set'
import _map from 'lodash/map'
import _find from 'lodash/find'
import _forEach from 'lodash/forEach'
import _isEmpty from 'lodash/isEmpty'
import React from 'react'
import { withFormik, Field } from 'formik'

import Button from '../../_library/Button'
import Select from '../../_library/Select'
import { getDayOptions } from '../../utils/ticketUtils'
import { RadioGroupField, SelectField, SimpleField } from '../../formik/Fields'
import { requiredValidator } from '../../../_common/core/validation'
import DelegationFormMobile from './DelegationFormMobile'

function validateDelegation(data) {
  const errors = {}

  if (!_get(data, 'name')) {
    _set(errors, 'name', 'Required')
  }

  const checkDuplicates = []

  const types = _get(data, 'types')
  types.forEach((type, index) => {
    if (!type.ticketTypeId) {
      _set(errors, 'types[' + index + '].ticketTypeId', 'Required')
      if (type.selectedGroup) {
        !type.selectedDay && _set(errors, 'types[' + index + '].selectedDay', 'Required')
        !type.selectedTime && _set(errors, 'types[' + index + '].selectedTime', 'Required')
      }
    }
    if (!type.maxQuantity) {
      _set(errors, 'types[' + index + '].maxQuantity', 'Required')
    }

    if (type.isGuestTicket == 0 && !type.invitationTemplateId) {
      _set(errors, 'types[' + index + '].invitationTemplateId', 'Required')
    }

    if (checkDuplicates.indexOf(type.isGuestTicket + '-' + type.ticketTypeId) !== -1) {
      _set(errors, 'types[' + index + '].ticketTypeId', 'Duplicate')
    }

    checkDuplicates.push(type.isGuestTicket + '-' + type.ticketTypeId)
  })

  return errors
}

class NewDelegationFormComponent extends React.Component {
  constructor(props) {
    super(props)
    this.isMobile = (window?.innerWidth || 1000) < 768
  }

  addNewTicketType = () => {
    this.props.setFieldValue('types', [
      ...this.props.values.types,
      {
        ticketTypeId: '',
        maxQuantity: 1,
        isGuestTicket: true,
        invitationTemplateId: null,
        selectedGroup: '',
        selectedDay: '',
        selectedTime: '',
      },
    ])
  }

  removeTicketType = index => {
    const types = [...this.props.values.types]
    types.splice(index, 1)
    this.props.setFieldValue('types', types)
  }

  handleTimeChange = (e, index) => {
    const { values, tickets } = this.props
    const time = e.target.value
    if (!!time) {
      const selectedTicketType = _find(
        tickets[values.types[index].selectedGroup],
        t => t.slotStartDate === values.types[index].selectedDay + ' ' + time,
      )
      const updatedType = {
        ticketTypeId: selectedTicketType.id,
        selectedTime: time,
      }

      this.props.setFieldValue('types', this.getUpdatedTypes(index, updatedType))
    }
  }

  handleChangeTicketTypeID = (e, index) => {
    const v = e.target.value
    const isTicketTypeID = (Number(v) || Number(v) === 0) && !v.includes('e')
    const updatedType = {
      ticketTypeId: isTicketTypeID ? v : '',
      selectedGroup: isTicketTypeID ? '' : v,
      selectedDay: '',
      selectedTime: '',
    }

    this.props.setFieldValue('types', this.getUpdatedTypes(index, updatedType))
  }

  getUpdatedTypes = (index, updatedType) => {
    const {
      values: { types },
    } = this.props
    return _map(types, (t, i) => (i === index ? { ...t, ...updatedType } : t))
  }

  showDayTimeSelects = value => !!value

  getTimeOptions = (dayOptions, day) => {
    const selectedDay = _find(dayOptions, d => d.value === day) || {}
    return selectedDay.timeOptions || [{ value: '', label: 'Time' }]
  }

  render() {
    const {
      event,
      isSubmitting,
      handleSubmit,
      onCancel,
      values,
      touched,
      errors,
      handleChange,
      handleBlur,
      tickets,
      tables,
      emailTemplates,
    } = this.props
    let ticketTableLabel = ''
    const optionsTickets = [{ value: '', label: '' }]
    const emailTemplatesOptions = [{ value: '', label: 'Email Template' }]
    _forEach(emailTemplates, template => {
      emailTemplatesOptions.push({ value: template.id, label: template.name })
    })

    if (!_isEmpty(tickets) && !_isEmpty(tables)) {
      ticketTableLabel = 'Ticket/Table Type'
    } else if (!_isEmpty(tables)) {
      ticketTableLabel = 'Table Type'
    } else {
      ticketTableLabel = 'Ticket Type'
    }
    optionsTickets[0] = { value: '', label: ticketTableLabel }

    _forEach(tickets, (ticket, i) => {
      optionsTickets.push({
        value: ticket.id || i,
        label: ticket.displayName || i,
      })
    })

    _forEach(tables, table => {
      if (table.active) {
        const key = table.displayName || table.name
        optionsTickets.push({ value: table.id || key, label: key })
      }
    })

    return (
      <form
        ref="form"
        method="POST"
        onSubmit={handleSubmit}
        style={
          this.isMobile ? { display: 'flex', flexDirection: 'column', gap: 10, justifyContent: 'center' } : {}
        }
      >
        <div className="row">
          <div className="col-sm-12 col-xs-12">
            <Field
              name="name"
              label="Delegation Name"
              placeholder="Who will you be giving access to?"
              onChange={handleChange}
              onBlur={handleBlur}
              component={SimpleField}
            />
          </div>
        </div>
        {values.types.length > 0 ? (
          this.isMobile ? (
            values.types.map((type, index) => (
              <DelegationFormMobile
                index={index}
                values={values}
                errors={errors}
                touched={touched}
                handleChange={handleChange}
                handleBlur={handleBlur}
                optionsTickets={optionsTickets}
                emailTemplatesOptions={emailTemplatesOptions}
                showDayTimeSelects={this.showDayTimeSelects}
                handleChangeTicketTypeID={this.handleChangeTicketTypeID}
                removeTicketType={this.removeTicketType}
              />
            ))
          ) : (
            <table className="table new-delegate-tickets-table">
              <thead className="hidden-xs">
                <tr>
                  <th>{ticketTableLabel}</th>
                  <th>Type</th>
                  <th>Quantity</th>
                  <th>Email Template</th>
                  <th />
                </tr>
              </thead>

              {values.types.map((type, index) => (
                <tbody key={index} className="delegation">
                  <tr key={index} className="delegation-row">
                    <td>
                      <div className="visible-xs mobile-field-label">{ticketTableLabel}</div>
                      <Select
                        options={optionsTickets}
                        id={'types[' + index + '].ticketTypeId'}
                        style={{ width: '100%', minWidth: '140px' }}
                        value={
                          this.showDayTimeSelects(values.types[index].selectedGroup)
                            ? values.types[index].selectedGroup
                            : values.types[index].ticketTypeId
                        }
                        error={
                          this.showDayTimeSelects(values.types[index].selectedGroup)
                            ? errors.types && errors.types[index] && errors.types[index].selectedGroup
                            : errors.types && errors.types[index] && errors.types[index].ticketTypeId
                        }
                        touched={
                          this.showDayTimeSelects(values.types[index].selectedGroup)
                            ? touched.types && touched.types[index] && touched.types[index].selectedGroup
                            : touched.types && touched.types[index] && touched.types[index].ticketTypeId
                        }
                        onChange={e => this.handleChangeTicketTypeID(e, index)}
                        onBlur={handleBlur}
                      />
                    </td>
                    <td>
                      <div className="visible-xs mobile-field-label">Type</div>
                      <Field
                        name={'types[' + index + '].isGuestTicket'}
                        id={'types[' + index + '].isGuestTicket'}
                        style={{ width: '100%', minWidth: '140px' }}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        component={SelectField}
                        options={[
                          { value: 1, label: 'Guest Ticket' },
                          { value: 0, label: 'Invitation' },
                        ]}
                        validate={requiredValidator()}
                      />
                    </td>
                    <td>
                      <div className="visible-xs mobile-field-label">Quantity</div>
                      <Field
                        type="number"
                        name={'types[' + index + '].maxQuantity'}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        component={SimpleField}
                        style={{ width: '100%' }}
                      />
                    </td>
                    <td>
                      <div className="visible-xs mobile-field-label">Email Template</div>
                      <Field
                        name={'types[' + index + '].invitationTemplateId'}
                        id={'types[' + index + '].invitationTemplateId'}
                        onChange={handleChange}
                        component={SelectField}
                        options={emailTemplatesOptions}
                        validate={requiredValidator()}
                        disabled={values.types[index].isGuestTicket == 1}
                        style={{
                          opacity: values.types[index].isGuestTicket == 1 ? 0.5 : 1,
                          width: '100%',
                          minWidth: '150px',
                        }}
                      />
                    </td>
                    <td className="text-right">
                      <Button
                        className="btn btn-danger btn-shadow new-delegation-delete-type-btn mobile-full-width"
                        type="button"
                        style={{ minWidth: '20px' }}
                        onClick={() => this.removeTicketType(index)}
                      >
                        <i className="fa fa-trash" />
                      </Button>
                    </td>
                  </tr>
                  {this.showDayTimeSelects(values.types[index].selectedGroup) && (
                    <tr>
                      <td>
                        <div className="visible-xs mobile-field-label">Ticket Day</div>
                        <Select
                          id={'types[' + index + '].selectedDay'}
                          label="Ticket Day"
                          options={getDayOptions(tickets, values.types[index].selectedGroup)}
                          value={values.types[index].selectedDay}
                          error={errors.types && errors.types[index] && errors.types[index].selectedDay}
                          touched={touched.types && touched.types[index] && touched.types[index].selectedDay}
                          onChange={handleChange}
                          style={{ width: '100%' }}
                        />
                      </td>
                      <td>
                        <div className="visible-xs mobile-field-label">Ticket Time</div>
                        <Select
                          id={'types[' + index + '].selectedTime'}
                          label="Ticket Time"
                          options={this.getTimeOptions(
                            getDayOptions(tickets, values.types[index].selectedGroup),
                            values.types[index].selectedDay,
                          )}
                          value={values.types[index].selectedTime}
                          error={errors.types && errors.types[index] && errors.types[index].selectedTime}
                          touched={touched.types && touched.types[index] && touched.types[index].selectedTime}
                          onChange={e => this.handleTimeChange(e, index)}
                          style={{ width: '100%' }}
                        />
                      </td>
                      <td className="text-right" />
                    </tr>
                  )}
                </tbody>
              ))}
            </table>
          )
        ) : null}

        <div className="text-center">
          <div className="action-buttons" style={{ display: 'flex', gap: 15 }}>
            <Button
              className="btn btn-primary btn-shadow mobile-full-width"
              type="button"
              onClick={() => this.addNewTicketType()}
              style={{ marginRight: '10px', marginBottom: '10px' }}
            >
              Add Ticket Type
            </Button>
            <Button
              className="btn btn-success mobile-full-width"
              type="button"
              onClick={() => {}}
              style={{ marginBottom: '10px' }}
            >
              <a
                style={{ color: 'white' }}
                href={`/event/${event?.id}/email-templates`}
                target="_blank"
                rel="noreferrer"
              >
                Create Email Template
              </a>
            </Button>
          </div>
        </div>

        <div style={{ textAlign: 'right' }}>
          {values.types && values.types.length > 0 && (
            <Button
              className="btn btn-primary btn-shadow mobile-full-width"
              type="submit"
              loading={isSubmitting}
              style={{ marginRight: '10px', marginBottom: '10px' }}
            >
              Create
            </Button>
          )}
          <Button
            className="btn btn-danger btn-shadow mobile-full-width"
            type="button"
            onClick={onCancel}
            disabled={isSubmitting}
            style={{ marginBottom: '10px' }}
          >
            Cancel
          </Button>
        </div>
      </form>
    )
  }
}

const NewDelegationForm = withFormik({
  mapPropsToValues: props => ({
    name: _get(props, 'initialValues.attributes.name') || '',
    types: _get(props, 'initialValues.attributes.types') || [],
    isGuestTicket: _get(props, 'initialValues.attributes.isGuestTicket', true) ? 1 : 0,
  }),

  // Custom sync validation
  validate: values => validateDelegation(values),

  handleSubmit: (values, { props, setSubmitting }) => {
    const updatedValues = {
      name: values.name,
      types: _map(values.types, t => ({
        ticketTypeId: t.ticketTypeId,
        maxQuantity: t.maxQuantity,
        isGuestTicket: t.isGuestTicket,
        invitationTemplateId: parseInt(t.invitationTemplateId),
      })),
      isGuestTicket: values.isGuestTicket === 1,
      invitationTemplateId: values.isGuestTicket === 0 ? parseInt(values.invitationTemplateId) : null,
    }
    props
      .onSubmit({
        attributes: { ...updatedValues },
      })
      .then(v => {
        setSubmitting(false)
      })
      .catch(err => {
        setSubmitting(false)
      })
  },
  displayName: 'NewDelegationForm', // helps with React DevTools
})(NewDelegationFormComponent)

export default NewDelegationForm
